import React, { useState } from "react";
import { Button, Dropdown, Menu } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { YhAuth } from "@/components/auth/YhAuth";
import { useSaleDcDetailsModel } from "./details/saleDcDetailsModel";
import { useSaleDcModel } from "../seleDcModel";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { PrintTable } from "./PrintTable";
import useGlobalModel from "@/model/globalModel";

export const DataBox = () => {
    const { selectedRowKeys, statistics, dataSource, exportSaleDc, exportStatisticsExport } = useSaleDcModel();
    const { resetEditCatch } = useSaleDcDetailsModel();
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => []);
    const { user: { shopCode } } = useGlobalModel();
    const [printVisible, setPrintVisible] = useState<boolean>(false);

    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        if (dataSource.find((item: any) => item.id == selectedRowKeys[0])?.outShopCode !== shopCode) {
            globalPrompt("message", { text: "请选择本站点下的工单进行编辑，可以点击单号进入查看哦！", type: "warning" });
            return;
        }
        let SaleDcEditKey = "16-2-2";
        let isFindNav = findNav(SaleDcEditKey);
        if (!isFindNav) {
            addNav(SaleDcEditKey, { id: selectedRowKeys[0] as string, mode: "edit" });
            resetEditCatch()
        } else {
            globalPrompt("modal", {
                title: "调出单跳转详情",
                type: "warning",
                text: "您还有调出单单详情未保存，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(SaleDcEditKey, { id: selectedRowKeys[0] as string, mode: "edit" });
                    resetEditCatch()
                }
            })
        }
    }

    const onPrint = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行打印，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        setPrintVisible(true);
    }

    const desc: IDescription[] = [
        {
            label: "调出数量",
            value: statistics?.totalNum,
            color: DescriptionColorEnum.green
        },
        {
            label: "应收金额",
            value: `￥${statistics?.totalAmount}`,
            color: DescriptionColorEnum.red
        },
    ]
    const printMenu = (
        <Menu>
            <Menu.Item key="1" onClick={() => exportSaleDc()}>
                列表导出
            </Menu.Item>
            <Menu.Item key="0" onClick={() => exportStatisticsExport()}>
                明细导出
            </Menu.Item>
        </Menu>
    );
    const action = <>
        <YhAuth resCode={ResourceAuthEnum.S_DC_AD}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => addNav("16-2-1", { id: "", mode: "add" })}
            >新增</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.S_DC_ED}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onEdit}
            >编辑</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.S_DC_EX}>
            {/* <Dropdown overlay={printMenu} trigger={['hover']}> */}
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => exportSaleDc()}
            >导出</Button>
            {/* </Dropdown> */}
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_APPROVAL_PRINT}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => onPrint()}
            >打印</Button>
        </YhAuth>
    </>;

    return (
        <>
            <YhBox action={action} style={{ height: 'calc(100vh - 180px)' }}>
                <DataTable />
            </YhBox>
            <PrintTable printVisible={printVisible} setPrintVisible={setPrintVisible} />
        </>
    )
}